import {NgModule} from '@angular/core';
import {EntityDataService, EntityServices} from '@ngrx/data';
import {ReportComponentConverter} from './api/entity/converter/reportComponent.converter';
import {ReportComponentSummaryConverter} from './api/entity/converter/reportComponentSummary.converter';
import {ReportComponentRepository} from './impl/service/ngrx/reportComponent.repository';
import {ReportComponentDataService} from './impl/service/ngrx/reportComponentData.service';
import {ReportComponentDataServiceAdapter} from './impl/service/ngrx/reportComponentDataService.adapter';
import {ReportComponentSummaryDataServiceAdapter} from './impl/service/ngrx/reportComponentSummaryDataService.adapter';
import {errorMessages} from '../../core/error/errorMessages';

@NgModule({
    providers: [
        ReportComponentConverter,
        ReportComponentSummaryConverter,
        ReportComponentDataService,
        ReportComponentRepository,
        ReportComponentDataServiceAdapter,
        ReportComponentSummaryDataServiceAdapter,
    ],
    imports: []
})
export class ReportingComponentModule {
    constructor(entityDataService: EntityDataService,
                entityServices: EntityServices,
                repository: ReportComponentRepository,
                dataService: ReportComponentDataService,
    ) {

        entityDataService.registerServices({
            'ReportComponent': dataService,
        });

        entityServices.registerEntityCollectionServices({
            'ReportComponent': repository,
        });

        errorMessages.set('REPORT_COMPONENT_SAVE_MAXIMUM_COMPONENT_COUNT_REACHED', 'Vous avez atteint votre quota pour ce type de composant');
    }
}
